import { Component, OnInit, Input } from '@angular/core'
import { Pet } from '@app/models/pet.model'
import { Observable } from 'rxjs'

@Component({
	selector: 'app-pet-quote-details',
	templateUrl: './pet-quote-details.component.html',
	styleUrls: ['./pet-quote-details.component.scss'],
})
export class PetQuoteDetailsComponent implements OnInit {
	@Input() pets!: Pet[]

	constructor() {}

	ngOnInit(): void {}
}
